import { object } from '../typing/object.js';
import { EventAuth } from '../event-store/event-auth.js';
import { string } from '../typing/string.js';
import { record } from '../typing/record.js';
import { TypeOf } from '../typing/type-of.js';

export const UserContext = object('UserContext', {
  auth: EventAuth,
  authId: string(),
  args: record(string(), string()),
  name: string(),
});
export type UserContext = TypeOf<typeof UserContext>;
